import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { MatSidenav } from '@angular/material/sidenav';

import { ManageUsersService } from '../manage-users/manage-users.service';

import { saveAs } from 'file-saver';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface currUsu {
 data:[{etiqueta:string, contingut:string}],
 projects:[{titol:string, data_aprovacio:string}]
}

@Component({
  selector: 'app-manage-curriculum',
  templateUrl: './manage-curriculum.component.html',
  styleUrls: ['./manage-curriculum.component.scss']
})

export class ManageCurriculumComponent implements OnInit {
  public userCurr: any;
  public usuari: string = '';
  public nom: string = '';
  public enData: string = Date();
  public nombre: number = 10;
  public idioma: string = 'ca';
  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(private manageUsersService: ManageUsersService, private dialogRef: MatDialogRef<ManageCurriculumComponent>, @Inject(MAT_DIALOG_DATA) private data) {
    this.usuari = data.id;this.nom = data.nom;this.canviar();
  }

  canviar(){ this.manageUsersService.getCurr(this.usuari,this.idioma,this.nombre).subscribe(uCurr => {this.userCurr = uCurr;}); }
  desar(){ this.manageUsersService.setCurr(this.usuari,this.idioma,this.userCurr['data']).subscribe(userCurr => { }); }
  
  public onFileChange(event){
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(file.size > 5000000){
          alert("Mida límit del fitxer 5Mb!");
          this.userCurr.data.filter(selec => selec.camp == 'filename' ).map(item => item.contingut = '');
          return;
        };
        this.userCurr.data.filter(selec => selec.camp == 'filename' ).map(item => item.contingut = file.name);
        this.userCurr.data.file = {
          filename: file.name,
          filetype: file.type,
          value: reader.result
        };
      };
    }else {this.userCurr.data.file = null;this.userCurr.data.filename = '';}
  }

  exportar(){
    var columnsDef = {'ca': ['', 'Projecte', 'Període'],'es': ['', 'Proyecto', 'Período'],'en': ['', 'Project', 'Period'],'br': ['', 'Projeto', 'Período'] };
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Curriculum "+this.usuari+"</title>";
    
    var postHtml = "</body></html>";
    var dataI;
    var dataF;

    var css = (
     '<style>' +
     'body: {font-family: "Open Sans",Calibri;font-size:13px}' +
     'table {font-family: "Open Sans",Calibri;font-size:13px;width:100;font-size:13px}' +
     'tr, td {font-size:13px}' +
     'h4 {font-family: "Open Sans", Calibri}' +
     '<!-- ' +
     ' @page{' +
     '	size: 21cm 29.7cm;  /* A4 */' +
     '	margin: 2cm 2cm 2cm 2cm; /* Margins: 2 cm on each side */' +
     '	mso-page-orientation: portrait;' +
	 ' }' +
	 '-->' +
	 ' p.MsoHeader, li.MsoHeader, div.MsoHeader{' +
	 ' margin:0in;' +
     ' margin-top:.0001pt;' +
	 ' mso-pagination:widow-orphan;' +
	 ' tab-stops:center 3.0in right 6.0in;' +
	 ' }' +
	 ' p.MsoFooter, li.MsoFooter, div.MsoFooter{' +
	 ' margin:0in 0in 1in 0in;' +
	 ' margin-bottom:.0001pt;' +
	 ' mso-pagination:widow-orphan;' +
	 ' tab-stops:center 3.0in right 6.0in;' +
	 ' }' +
	 ' .footer { font-size: 11px; }' +
	 ' @page Section{' +
	 '    size:8.5in 11.0in;' +
	 '    margin:0.5in 0.5in 0.5in 0.5in;' +
	 '    mso-header-margin:0.5in;' +
	 '    mso-header:h1;' +
	 '    mso-footer:f1;' +
	 '    mso-footer-margin:0.5in;' +
	 '    mso-paper-source:0;' +
	 ' }' +
 	 ' div.Section {' +
     '  page: Section;' +
     ' }' +
     '</style>'
    );

    preHtml += css + "<link rel=File-List href='mydocument_files/filelist.xml'></head><body>";
    var elHtml = "<div class='Section' style='float:left;clear:both'><h4>"+(this.userCurr.projects?this.userCurr.projects[0].name:'');
    elHtml += (this.userCurr.projects?" / "+this.userCurr.projects[0].email:'');
    elHtml += (this.userCurr.projects?(this.userCurr.projects[0].telefon?" / "+this.userCurr.projects[0].telefon:''):'');
    elHtml += "</h4></div><br>";
    elHtml += '<table style="margin-top:20px;width:100%/*;page-break-before: always*/" width="100%" cellpadding="2" cellspacing="0">';
    this.userCurr.data.map(item => {
      elHtml += "<tr style='background-color:#EEEEEE'><td><b>"+item.etiqueta+"</b></td></tr>";
      elHtml += "<tr style=''><td style='page-break-inside:avoid;white-space: pre-wrap'>"+(item.contingut?item.contingut.replace(/\n/g, '<br>\n'):'')+"<br></td></tr>";
    });

    elHtml += "</table><br><br><br><table style='float:left;clear:both;width:100%; border:0px; border-bottom: 1px solid #EEEEEE'><tr>";
    columnsDef[this.idioma].map(item => {if(item !== '')elHtml += "<th style='background-color:#EEEEEE'>"+item+"</th>";});
    elHtml += "</tr>";
  	this.userCurr.projects.map(item => {
  	  elHtml += "<td style='page-break-inside:avoid'>"+item.titol+"</td>";
  	  dataI = new Date(item.data_aprovacio).getFullYear();
  	  dataF = (item.data_finalitzacio?new Date(item.data_finalitzacio).getFullYear():null);
      elHtml += "<td style='width:200px;text-align:center'>"+dataI+"-"+dataF+"</td></tr>";
    });
    elHtml += "</table>";
    elHtml = preHtml + elHtml + postHtml;

    var link = document.createElement('a');
    link.setAttribute('download', 'curriculum-'+this.usuari+'.doc');
    link.setAttribute('href','data:text/doc;charset=utf-8,'+encodeURIComponent(elHtml));
    link.click();
  }
  tancar(){ this.dialogRef.close(); }

  ngOnInit(){
   this.canviar();
   history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
